'use strict'

import Vue from 'vue'
import * as type from './types'
import actions from './actions'
import getters from './getters.js'

const state = {
  transport: [],
  transportRequest: null,
  transportEnums: {},
  createdShipment: null
}

const mutations = {
  [type.CREATE_TRANSPORT] (state, action) {
    transport.push(action.transport)
  },
  [type.SET_SELECTED_TRANSPORT] (state, action) {
    state.transportRequest = { ...state.transportRequest, ...action.transport }
  },
  [type.SET_SELECTED_TRANSPORT_PRIORITY] (state, action) {
    state.transportRequest = { ...state.transportRequest, priority: action.value }
  },
  [type.SET_SELECTED_TRANSPORT_STATUS] (state, action) {
    state.transportRequest = { ...state.transportRequest, status: action.value }
  },
  [type.SET_SELECTED_TRANSPORT_INCOTERMS] (state, action) {
    state.transportRequest = { ...state.transportRequest, incoterms: action.value }
  },
  [type.SET_SELECTED_TRANSPORT_COMMENT] (state, action) {
    state.transportRequest = { ...state.transportRequest, comment: action.value }
  },
  [type.SET_SELECTED_TRANSPORT_RESTRICTIONS] (state, action) {
    state.transportRequest = { ...state.transportRequest, restrictions: action.value }
  },
  [type.UPDATE_TRANSPORT_UNITS] (state, action) {
    state.transportRequest = { ...state.transportRequest, units: action.units }
  },
  [type.SET_SELECTED_TRANSPORT_PICKUP_DELIVERY] (state, action) {
    state.transportRequest = { ...state.transportRequest, ...action.value }
  },
  [type.SET_SELECTED_ORDER_ORIGIN_LOCATION] (state, action) {
    const origin = { ...state.transportRequest.origin, ...action.location }
    state.transportRequest = { ...state.transportRequest, origin }
  },
  [type.SET_SELECTED_ORDER_DESTINATION_LOCATION] (state, action) {
    const destination = { ...state.transportRequest.destination, ...action.location }
    state.transportRequest = { ...state.transportRequest, destination }
  },
  [type.SET_TRANSPORT_ENUMS] (state, action) {
    state.transportEnums = { ...state.transportEnums, ...action }
  },
  [type.IS_CREATING_SHIPMENT] (state, action) {
    state.createdShipment = action.state
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}
